import config from 'constants/config'

export const selectOfferComparisonEnabled = (state: App.State) => config.SEARCH_OFFER_COMPARISON_ENABLED && state.offerComparison.enabled

export const selectOfferComparisonSelections = (state: App.State) => state.offerComparison.selections
